 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"auth-pages-login-login-module":"auth-pages-login-login-module","auth-pages-mantenimiento-mantenimiento-module":"auth-pages-mantenimiento-mantenimiento-module","moduloConsulta-recepcion-pages-recepcion-home-recepcion-home-module":"moduloConsulta-recepcion-pages-recepcion-home-recepcion-home-module","moduloLaboratorio-laboratorio-pages-laboratorio-home-laboratorio-home-module":"moduloLaboratorio-laboratorio-pages-laboratorio-home-laboratorio-home-module","shared-pages-admin-home-admin-home-module":"shared-pages-admin-home-admin-home-module","sweetalert2":"sweetalert2","auth-pages-perfil-perfil-module":"auth-pages-perfil-perfil-module","default~auth-pages-actividad-actividad-module~bitacora-pages-bitacora-general-bitacora-general-modul~cbc5290c":"default~auth-pages-actividad-actividad-module~bitacora-pages-bitacora-general-bitacora-general-modul~cbc5290c","auth-pages-actividad-actividad-module":"auth-pages-actividad-actividad-module","default~home-home-module~moduloEmpleados-empleados-pages-asistencias-asistencias-module~moduloEmplea~693732e3":"default~home-home-module~moduloEmpleados-empleados-pages-asistencias-asistencias-module~moduloEmplea~693732e3","default~home-home-module~moduloEmpleados-empleados-pages-asistencias-asistencias-module~moduloEmplea~54b59dcd":"default~home-home-module~moduloEmpleados-empleados-pages-asistencias-asistencias-module~moduloEmplea~54b59dcd","home-home-module":"home-home-module","default~moduloConsulta-consulta-pages-consulta-consulta-module~moduloConsulta-pacientes-pages-archiv~907335a1":"default~moduloConsulta-consulta-pages-consulta-consulta-module~moduloConsulta-pacientes-pages-archiv~907335a1","moduloConsulta-pacientes-pages-archivo-archivo-module":"moduloConsulta-pacientes-pages-archivo-archivo-module","default~moduloConsulta-consulta-pages-consulta-consulta-module~moduloInventario-compras-pages-compra~9df321b8":"default~moduloConsulta-consulta-pages-consulta-consulta-module~moduloInventario-compras-pages-compra~9df321b8","default~moduloConsulta-consulta-pages-consulta-consulta-module~moduloInventario-insumos-pages-insumo~dd74c223":"default~moduloConsulta-consulta-pages-consulta-consulta-module~moduloInventario-insumos-pages-insumo~dd74c223","moduloInventario-insumos-pages-insumos-medicos-insumos-medicos-module":"moduloInventario-insumos-pages-insumos-medicos-insumos-medicos-module","moduloInventario-insumos-pages-kardex-articulo-kardex-articulo-module":"moduloInventario-insumos-pages-kardex-articulo-kardex-articulo-module","moduloInventario-insumos-pages-mostrar-articulo-mostrar-articulo-module":"moduloInventario-insumos-pages-mostrar-articulo-mostrar-articulo-module","moduloInventario-insumos-pages-nuevo-articulo-nuevo-articulo-module":"moduloInventario-insumos-pages-nuevo-articulo-nuevo-articulo-module","moduloInventario-compras-pages-compra-compra-module":"moduloInventario-compras-pages-compra-compra-module","moduloInventario-compras-pages-compras-compras-module":"moduloInventario-compras-pages-compras-compras-module","moduloInventario-compras-pages-solicitud-solicitud-module":"moduloInventario-compras-pages-solicitud-solicitud-module","moduloInventario-compras-pages-solicitudes-solicitudes-module":"moduloInventario-compras-pages-solicitudes-solicitudes-module","default~moduloConsulta-consulta-pages-consulta-consulta-module~moduloLaboratorio-ordenes-pages-orden~d1382b9d":"default~moduloConsulta-consulta-pages-consulta-consulta-module~moduloLaboratorio-ordenes-pages-orden~d1382b9d","default~moduloConsulta-consulta-pages-consulta-consulta-module~moduloConsulta-consulta-pages-mostrar~3d985fd0":"default~moduloConsulta-consulta-pages-consulta-consulta-module~moduloConsulta-consulta-pages-mostrar~3d985fd0","default~moduloConsulta-consulta-pages-consulta-consulta-module~pacientes-pages-expediente-expediente-module":"default~moduloConsulta-consulta-pages-consulta-consulta-module~pacientes-pages-expediente-expediente-module","pacientes-pages-expediente-expediente-module":"pacientes-pages-expediente-expediente-module","default~moduloLaboratorio-resultados-pages-orden-consulta-orden-consulta-module~moduloLaboratorio-re~b4c0800f":"default~moduloLaboratorio-resultados-pages-orden-consulta-orden-consulta-module~moduloLaboratorio-re~b4c0800f","moduloLaboratorio-resultados-pages-orden-consulta-orden-consulta-module":"moduloLaboratorio-resultados-pages-orden-consulta-orden-consulta-module","moduloLaboratorio-ordenes-pages-orden-resultados-orden-resultados-module":"moduloLaboratorio-ordenes-pages-orden-resultados-orden-resultados-module","default~moduloInventario-proveedores-pages-mostrar-proveedor-mostrar-proveedor-module~moduloInventar~c5126d64":"default~moduloInventario-proveedores-pages-mostrar-proveedor-mostrar-proveedor-module~moduloInventar~c5126d64","moduloInventario-proveedores-pages-mostrar-proveedor-mostrar-proveedor-module":"moduloInventario-proveedores-pages-mostrar-proveedor-mostrar-proveedor-module","moduloInventario-proveedores-pages-nuevo-proveedor-nuevo-proveedor-module":"moduloInventario-proveedores-pages-nuevo-proveedor-nuevo-proveedor-module","moduloInventario-proveedores-pages-proveedores-proveedores-module":"moduloInventario-proveedores-pages-proveedores-proveedores-module","default~moduloLaboratorio-ordenes-particulares-pages-clientes-clientes-module~moduloLaboratorio-orde~90725bae":"default~moduloLaboratorio-ordenes-particulares-pages-clientes-clientes-module~moduloLaboratorio-orde~90725bae","moduloLaboratorio-resultados-pages-orden-particular-orden-particular-module":"moduloLaboratorio-resultados-pages-orden-particular-orden-particular-module","moduloLaboratorio-ordenes-particulares-pages-clientes-clientes-module":"moduloLaboratorio-ordenes-particulares-pages-clientes-clientes-module","moduloLaboratorio-ordenes-particulares-pages-formulario-orden-formulario-orden-module":"moduloLaboratorio-ordenes-particulares-pages-formulario-orden-formulario-orden-module","moduloLaboratorio-ordenes-particulares-pages-mostrar-cliente-mostrar-cliente-module":"moduloLaboratorio-ordenes-particulares-pages-mostrar-cliente-mostrar-cliente-module","moduloLaboratorio-ordenes-particulares-pages-mostrar-orden-particular-mostrar-orden-particular-module":"moduloLaboratorio-ordenes-particulares-pages-mostrar-orden-particular-mostrar-orden-particular-module","moduloLaboratorio-ordenes-particulares-pages-ordenes-particulares-ordenes-particulares-module":"moduloLaboratorio-ordenes-particulares-pages-ordenes-particulares-ordenes-particulares-module","moduloLaboratorio-ordenes-particulares-pages-registro-cliente-registro-cliente-module":"moduloLaboratorio-ordenes-particulares-pages-registro-cliente-registro-cliente-module","moduloLaboratorio-resultados-pages-produccion-ordenes-produccion-ordenes-module":"moduloLaboratorio-resultados-pages-produccion-ordenes-produccion-ordenes-module","moduloConsulta-consulta-pages-indicaciones-indicaciones-module":"moduloConsulta-consulta-pages-indicaciones-indicaciones-module","moduloLaboratorio-ordenes-pages-ordenes-ordenes-module":"moduloLaboratorio-ordenes-pages-ordenes-ordenes-module","pacientes-pages-expedientes-expedientes-module":"pacientes-pages-expedientes-expedientes-module","pacientes-pages-formulario-paciente-formulario-pacientes-module":"pacientes-pages-formulario-paciente-formulario-pacientes-module","moduloLaboratorio-catalogo-pages-formulario-catalogo-formulario-catalogo-module":"moduloLaboratorio-catalogo-pages-formulario-catalogo-formulario-catalogo-module","auth-pages-formulario-usuario-formulario-usuario-module":"auth-pages-formulario-usuario-formulario-usuario-module","bitacora-pages-bitacora-general-bitacora-general-module":"bitacora-pages-bitacora-general-bitacora-general-module","bitacora-pages-bitacora-usuario-bitacora-usuario-module":"bitacora-pages-bitacora-usuario-bitacora-usuario-module","moduloEmpleados-empleados-pages-asistencias-asistencias-module":"moduloEmpleados-empleados-pages-asistencias-asistencias-module","moduloEmpleados-empleados-pages-control-asistencia-control-asistencia-module":"moduloEmpleados-empleados-pages-control-asistencia-control-asistencia-module","moduloEmpleados-empleados-pages-empleado-asistencias-empleado-asistencias-module":"moduloEmpleados-empleados-pages-empleado-asistencias-empleado-asistencias-module","moduloEmpleados-empleados-pages-empleados-empleados-module":"moduloEmpleados-empleados-pages-empleados-empleados-module","moduloEmpleados-empleados-pages-feriados-vacaciones-feriados-vacaciones-module":"moduloEmpleados-empleados-pages-feriados-vacaciones-feriados-vacaciones-module","moduloEmpleados-empleados-pages-nuevo-empleado-nuevo-empleado-module":"moduloEmpleados-empleados-pages-nuevo-empleado-nuevo-empleado-module","moduloEmpleados-empleados-pages-pago-empleados-pago-empleados-module":"moduloEmpleados-empleados-pages-pago-empleados-pago-empleados-module","moduloEmpleados-empleados-pages-pagos-pagos-module":"moduloEmpleados-empleados-pages-pagos-pagos-module","moduloEmpleados-empleados-pages-ver-empleado-ver-empleado-module":"moduloEmpleados-empleados-pages-ver-empleado-ver-empleado-module","moduloEmpleados-empleados-pages-ver-pago-ver-pago-module":"moduloEmpleados-empleados-pages-ver-pago-ver-pago-module","default~moduloEmpleados-licencias-pages-licencias-licencias-module~moduloEmpleados-licencias-pages-r~cce1e1bd":"default~moduloEmpleados-licencias-pages-licencias-licencias-module~moduloEmpleados-licencias-pages-r~cce1e1bd","moduloEmpleados-licencias-pages-licencias-licencias-module":"moduloEmpleados-licencias-pages-licencias-licencias-module","moduloEmpleados-licencias-pages-registro-licencias-registro-licencias-module":"moduloEmpleados-licencias-pages-registro-licencias-registro-licencias-module","moduloEmpleados-vacaciones-pages-vacaciones-vacaciones-module":"moduloEmpleados-vacaciones-pages-vacaciones-vacaciones-module","moduloConsulta-consulta-pages-mostrar-consulta-mostrar-consulta-module":"moduloConsulta-consulta-pages-mostrar-consulta-mostrar-consulta-module","moduloConsulta-consulta-pages-consulta-consulta-module":"moduloConsulta-consulta-pages-consulta-consulta-module","moduloActivoFijo-activos-pages-activos-fijos-activos-fijos-module":"moduloActivoFijo-activos-pages-activos-fijos-activos-fijos-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
